"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermittedAction = void 0;
let PermittedAction = exports.PermittedAction = /*#__PURE__*/function (PermittedAction) {
  PermittedAction["Delete"] = "delete";
  PermittedAction["Undelete"] = "undelete";
  PermittedAction["Edit"] = "edit";
  PermittedAction["CanEdit"] = "can_edit";
  PermittedAction["AddComment"] = "add_comment";
  PermittedAction["AddAttachment"] = "add_attachment";
  PermittedAction["RemoveAttachment"] = "remove_attachment";
  PermittedAction["ChangeOrder"] = "change_order";
  PermittedAction["ClearAssignee"] = "clear_assignee";
  PermittedAction["AssignAll"] = "assign_all";
  PermittedAction["AssignSameCompany"] = "assign_same_company";
  PermittedAction["Restore"] = "restore";
  return PermittedAction;
}({});
//# sourceMappingURL=common.js.map